module.exports = __webpack_public_path__ + "img/31.3ccbd442.jpg";